import React,{useContext,useEffect} from "react";
import redirectStudentHome from "../utils/redirectStudentHome";
import {AuthContext} from "../components/AuthContext";
export default function TutoringProspectRoute({children}){
 const {user,isAuthReady}=useContext(AuthContext);
 useEffect(()=>{if(isAuthReady && user?.role==='student')redirectStudentHome();},[isAuthReady,user?.role]);
 if(!isAuthReady || user?.role==='student')return null;
 return children;
}
